'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import SVGTextIconStyle from './SVGTextIconStyle';
import SVGWrapper from './SVGWrapper';

const SVGIcon = props => {
  const {
    wrapperProps,
    icon
  } = props,
        innerProps = _objectWithoutPropertiesLoose(props, ["wrapperProps", "icon"]);

  return /*#__PURE__*/_jsx(SVGWrapper, Object.assign({}, wrapperProps, {
    children: /*#__PURE__*/_jsx(SVGTextIconStyle, Object.assign({}, innerProps, {
      children: icon
    }))
  }));
};

SVGIcon.propTyes = {
  wrapperProps: PropTypes.node,
  icon: PropTypes.string
};
export default SVGIcon;